import parseISO from "date-fns/parseISO";
import _ from "lodash";
import { autorun, computed, observable, runInAction, when } from "mobx";
import { QueryClient } from "react-query";
import { GetEducationForCandidateResponse } from "../../../../api/candidate/getEducationForCandidate";
import { Store2 } from "../../../../WSUtils/Store";
import { UserInfo } from "../../../../WSUtils/UserInfo";
import { guid } from "../../../../WSUtils/util";
import {
  CVPSearchParams,
  queryStringStore,
} from "../../../../WSUtils/wsQueryStringStore";
import { CVEditContextStore } from "../../CVEditContext";
import {
  cveFieldStore,
  getCvEditFieldValueVersioner,
} from "../../Fields/CVEditBaseField";
import { CVEditEducation } from "./CVEditEducation";
import { CVEditEducationEditorStore } from "./CVEditEducationEditor";

export class CVEditEducationSegmentStore extends Store2<any> {
  declare userInfo: UserInfo;
  declare queryClient: QueryClient;
  declare cvEditContext: CVEditContextStore;

  @observable education: GetEducationForCandidateResponse;

  @observable educationEditorStore: CVEditEducationEditorStore;

  @computed get deletedListItems() {
    return [...this.deletedEducations.values()];
  }

  @computed get listItems() {
    return this.educationField.store.value.filter(
      (e) => !this.deletedEducations.has(e.id)
    );
  }

  @computed get editingEducationId() {
    return queryStringStore.qs[CVPSearchParams.cvpedu];
  }

  @computed get nTotalListItems() {
    return this.listItems.length + this.deletedListItems.length;
  }

  @observable deletedEducations = observable.map<string, CVEditEducation>();

  @observable educationField = (() => {
    const _this = this;
    const store = cveFieldStore({
      value: [] as CVEditEducation[],
      get validationError(): string {
        return "";
      },
    });

    const valueVersioner = getCvEditFieldValueVersioner(
      store,
      0,
      false,
      "educationField"
    );

    this.dt.disposers.push(
      valueVersioner.onNewValue(() => {
        const data = this.education;
        if (!data?.ok) return;

        return {
          valueVersion: data?.valueVersion,
          getVal: () => {
            const values = (data?.items || []).map(
              (e) =>
                ({
                  id: e.id.toString(),
                  isNew: false,
                  description: e.comment,
                  from: e.fromDate ? parseISO(e.fromDate) : null,
                  to: e.toDate ? parseISO(e.toDate) : null,
                  educationTypeId: e.educationTypeId,
                  school: e.schoolName,
                } as CVEditEducation)
            );

            return _.orderBy(
              values,
              [(s) => s.from?.getTime() || 0, "id"],
              ["asc", "desc"]
            );
          },
        };
      })
    );

    return { store };
  })();
}
